import {useI18n} from "vue-i18n";
const BASE = "Aprèn - "

export const setMetadata = (screen) => {
    const { t } = useI18n();
    document.title = BASE + t(screen)
};

export const setMetadataProfessorName = (name) => {
    document.title = BASE + name.split(',')[1] +" "+ name.split(',')[0]
};

export const setMetadataName = (name) => {
    document.title = BASE + name
};


